import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import loading from '../assets/loading.gif';

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(function() {
    axios
      .get('https://akulweb.herokuapp.com/get-blogs')
      .then(res => {
        setIsLoading(false);
        setBlogs(res.data);
      })
      .catch(err => console.log(err));
  }, []);

  if (!isLoading) {
    return (
      <div className='pt-2'>
        <h3 className='oswald mb-3'>blogs</h3>
        {blogs.reverse().map(blog => (
          <div class='blog mt-1 mb-3' key={`${blog.serialId}-${blog.slug}`}>
            <Link to={`/blogs/${blog.serialId}/${blog.slug}`} className='link'>
              <h5 class='mb-0'>{blog.title}</h5>
            </Link>
            <div class='blogs-tags'>
              {blog.tags.map(tag => (
                <small class='blog-tag mr-2'>{tag}</small>
              ))}
            </div>
            <small>{blog.dateCreated}</small>
            <p class='mt-2'>{blog.description}</p>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div>
        <center>
          <img src={loading} alt='loading' className='loading' />
        </center>
      </div>
    );
  }
}
